const Loading = () => {
  window.scrollTo(0, 0);

  return (
    <div className="loading-container">
      <div className="loading-box"></div>
    </div>
  );
};

export default Loading;
